import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const ArcherDragHandle = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    <defs>
      <path
        id="ic_drag_texture-a"
        d="M10,17 C10.5522847,17 11,17.4477153 11,18 C11,18.5522847 10.5522847,19 10,19 C9.44771525,19 9,18.5522847 9,18 C9,17.4477153 9.44771525,17 10,17 Z M14,17 C14.5522847,17 15,17.4477153 15,18 C15,18.5522847 14.5522847,19 14,19 C13.4477153,19 13,18.5522847 13,18 C13,17.4477153 13.4477153,17 14,17 Z M10,13 C10.5522847,13 11,13.4477153 11,14 C11,14.5522847 10.5522847,15 10,15 C9.44771525,15 9,14.5522847 9,14 C9,13.4477153 9.44771525,13 10,13 Z M14,13 C14.5522847,13 15,13.4477153 15,14 C15,14.5522847 14.5522847,15 14,15 C13.4477153,15 13,14.5522847 13,14 C13,13.4477153 13.4477153,13 14,13 Z M10,9 C10.5522847,9 11,9.44771525 11,10 C11,10.5522847 10.5522847,11 10,11 C9.44771525,11 9,10.5522847 9,10 C9,9.44771525 9.44771525,9 10,9 Z M14,9 C14.5522847,9 15,9.44771525 15,10 C15,10.5522847 14.5522847,11 14,11 C13.4477153,11 13,10.5522847 13,10 C13,9.44771525 13.4477153,9 14,9 Z M10,5 C10.5522847,5 11,5.44771525 11,6 C11,6.55228475 10.5522847,7 10,7 C9.44771525,7 9,6.55228475 9,6 C9,5.44771525 9.44771525,5 10,5 Z M14,5 C14.5522847,5 15,5.44771525 15,6 C15,6.55228475 14.5522847,7 14,7 C13.4477153,7 13,6.55228475 13,6 C13,5.44771525 13.4477153,5 14,5 Z"
      />
      <rect id="ic_drag_texture-c" width="50" height="50" x="0" y="0" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="ic_drag_texture-b" fill="#fff">
        <use xlinkHref="#ic_drag_texture-a" />
      </mask>
      <use fill="#000" xlinkHref="#ic_drag_texture-a" />
      <g mask="url(#ic_drag_texture-b)">
        <use fill="#212121" transform="translate(-13 -13)" xlinkHref="#ic_drag_texture-c" />
      </g>
    </g>
  </svg>,
  'ArcherDragHandle'
);
